//Fetch_Token
export const FETCH_TOKEN_INPROGRESS = "FETCH_TOKEN_INPROGRESS";
export const FETCH_TOKEN_SUCCESS = "FETCH_TOKEN_SUCCESS";
export const FETCH_TOKEN_ERROR = "FETCH_TOKEN_ERROR";
export const REMOVE_TOKEN = "REMOVE_TOKEN";
export const SET_CODE = "SET_CODE";

export const FETCH_USER_INPROGRESS = "FETCH_USER_INPROGRESS";
export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const FETCH_USER_ERROR = "FETCH_USER_ERROR";

export const UPDATE_PATH = "UPDATE_PATH";

export const FETCH_TOP_ARTIST_INPROGRESS = "FETCH_TOP_ARTIST_INPROGRESS";
export const FETCH_TOP_ARTIST_SUCCESS = "FETCH_TOP_ARTIST_SUCCESS";
export const FETCH_TOP_ARTIST_ERROR = "FETCH_TOP_ARTIST_ERROR";

export const FETCH_TOP_TRACK_INPROGRESS = "FETCH_TOP_ARTIST_INPROGRESS";
export const FETCH_TOP_TRACK_SUCCESS = "FETCH_TOP_TRACK_SUCCESS";
export const FETCH_TOP_TRACK_ERROR = "FETCH_TOP_TRACK_ERROR";

export const FETCH_RECENTLY_PLAYED_INPROGRESS = "FETCH_RECENTLY_PLAYED_INPROGRESS";
export const FETCH_RECENTLY_PLAYED_SUCCESS = "FETCH_RECENTLY_PLAYED_SUCCESS";
export const FETCH_RECENTLY_PLAYED_ERROR = "FETCH_RECENTLY_PLAYED_ERROR";

export const FETCH_PLAYLIST_INPROGRESS = "FETCH_PLAYLIST_INPROGRESS";
export const FETCH_PLAYLIST_SUCCESS = "FETCH_PLAYLIST_SUCCESS";
export const FETCH_PLAYLIST_ERROR = "FETCH_PLAYLIST_ERROR";

export const FETCH_TRACK_DETAILS_INPROGRESS = "FETCH_TRACK_DETAILS_INPROGRESS";
export const FETCH_TRACK_DETAILS_SUCCESS = "FETCH_TRACK_DETAILS_SUCCESS";
export const FETCH_TRACK_DETAILS_ERROR = "FETCH_TRACK_DETAILS_ERROR";
export const CLEAR_TRACK_DETAILS = "CLEAR_TRACK_DETAILS";

export const FETCH_PLAYLIST_DETAIL_INPROGRESS = "FETCH_PLAYLIST_DETAIL_INPROGRESS";
export const FETCH_PLAYLIST_DETAIL_SUCCESS = "FETCH_PLAYLIST_DETAIL_SUCCESS";
export const FETCH_PLAYLIST_DETAIL_ERROR = "FETCH_PLAYLIST_DETAIL_ERROR";
export const CLEAR_PLAYLIST_DETAIL = "CLEAR_PLAYLIST_DETAIL";

export const CLEAR_ERROR = "CLEAR_ERROR";